module.exports = __webpack_public_path__ + "img/help-center-icon-0.e647f588.jpg";